import styled, { css } from 'styled-components';

import { theme } from '../../theme/config';

interface IDisabledProps {
    disabled?: boolean;
}

interface IInputProps extends IDisabledProps {
    hasError: boolean;
}

export const getBorderWidth = (hasError: boolean, isSelected: boolean) => {
    return isSelected || hasError ? '2px' : '1px';
};

export const getBorderColor = (hasError: boolean, isSelected: boolean) => {
    if (isSelected) {
        return theme.colors.bgSecondary;
    } else if (hasError) {
        return theme.colors.formError;
    }
    return theme.colors.mediumShadow;
};

export const getBorderShadow = (hasError: boolean, isSelected: boolean) =>
    `0 0 0 ${getBorderWidth(hasError, isSelected)} ${getBorderColor(
        hasError,
        isSelected
    )}`;

export const FormInputContainer = styled.div`
    display: flex;
    flex-flow: column;
    position: relative;
    width: 100%;
`;

export const StyledLabel = styled.label<IDisabledProps>`
    margin-bottom: 0.25rem;
    color: ${({ theme }) => theme.colors.fontPrimary};
    font-size: ${({ theme }) => theme.fontSizes[4]};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const InputStyle = css<IInputProps>`
    padding: 0.25rem 0.75rem;
    height: 2.25rem;
    max-height: 10rem;
    color: ${({ theme }) => theme.colors.formLabel};
    font-size: ${({ theme }) => theme.fontSizes[3]};
    border-radius: 0.375rem;
    border: none;
    box-shadow: ${({ hasError }) => getBorderShadow(hasError, false)};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

    &:focus {
        outline: none;
        box-shadow: ${({ hasError }) => getBorderShadow(hasError, true)};
    }
`;

export const StyledInput = styled.input<IInputProps>`
    ${InputStyle}
`;

export const StyledError = styled.span`
    min-height: 1.25rem;
    margin-top: 0.375rem;
    color: ${({ theme }) => theme.colors.formError};
    font-size: ${({ theme }) => theme.fontSizes[3]};
`;

export const StyleldButton = styled.button`
    border: none;
    width: 2rem;
    height: 2rem;
    position: absolute;
    right: 0.5rem;
    top: 1.75rem;
    cursor: pointer;
`;
